import { Pipe, PipeTransform } from '@angular/core';
import BaseAddressWithCountry from 'src/app/models/baseAddressWithCountry';
import { ICountry } from 'src/app/models/ICountry';

@Pipe({
  name: 'hasCountry'
})
export class HasCountryPipe implements PipeTransform {
  transform(value: any): boolean {
    return value && (value instanceof BaseAddressWithCountry || 'countryId' in value);
  }
}
